import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {ReactComponent as Arrow} from "../img/arrow.svg";
import {ReactComponent as FooterMobileSvg} from "../img/footermobile.svg";
import {ReactComponent as Mail} from "../img/mail.svg";
import { translate } from '../dictionaries';

const useStyles = makeStyles(() => ({
    wrap: {
        height: 651
    },
    topBlock: {
        position: 'relative', 
        width: '100%', 
        height: '511px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        flexDirection: 'column', 
        textAlign: 'center'
    },
    root: {
        position: 'relative', 
        display: 'flex', 
        maxWidth: 800, 
        width: '100%', 
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        color: '#fff', 
        fontFamily: 'Calibri, sans-serif', 
        fontWeight: 300, 
        fontSize: 26, 
        textTransform: "uppercase",
        lineHeight: 1.5,
        position: 'relative',
        zIndex: 2,
    },
    titleText: {
        fontWeight: 700, 
        fontFamily: 'Calibri, sans-serif',
    },
    btn: {
        display: 'flex', 
        alignItems: 'center', 
        background: '#ffb800',
        width: '65px',
        height: '20px', 
        padding: '15px 14px 8px', 
        borderRadius: 3, 
        cursor: 'pointer',
        position: 'relative', 
        zIndex: 2,
    },
    arrow: {
        fill: '#000', 
        width: 14, 
        height: 14, 
        marginLeft: 3, 
        marginBottom: 3,
        position: 'absolute',
        top: '37%', 
        right: 5,
    },
    btnTitle: {
        fontSize: 19, 
        textTransform: 'uppercase', 
        fontFamily: 'Calibri, sans-serif', 
        fontWeight: 700, 
        userSelect: 'none',
    },
    box: {
        position: 'absolute', 
        bottom: 0, 
        right: 20, 
        zIndex: -1,
    },
    description: {
        color: '#ffffff',
        fontFamily: 'Calibri',
        fontSize: 14,
        fontWeight: 300,
    },
    svg: {
        position: 'absolute',
        top: '12%',
        zIndex: 1,
    },
    wrapBottom: {
        height: 140, 
        background: '#aa200c', 
        padding: '3px 50px',
    },
    mail: {
        background: '#fff',
        marginRight: 10,
    }
}));

const FooterMobile = () => {
    const classes = useStyles();

    return (
        <div className={classes.wrap}>
        <div className={classes.topBlock}>
             <p className={classes.title}>
                <span className={classes.titleText}>{translate('common.test')}</span><br/> {translate('common.now')}
            </p>
            
            <div 
                onClick={() => window.location.replace('https://my.zzlogistics.ru/authorization/signup')}
                className={classes.btn}
                >
                <p className={classes.btnTitle}>
                    {translate('common.sign')}
                </p>
                <Arrow  className={classes.arrow}/>
            </div>
            <div className={classes.svg}>
                <FooterMobileSvg />
            </div>
        </div>
        <div className={classes.wrapBottom}>
            
            <p className={classes.description}>
                <Mail className={classes.mail}/>
                info@zzlogistics.ru
            </p>
            
            <p className={classes.description}>
                Copyright © Topzakazz 2015-2020
            </p>
            <p className={classes.description}>
                {translate('common.rules')}
            </p>
            <p className={classes.description}>
                {translate('common.political')}
            </p>
        </div>
        </div>
    )
}

export default FooterMobile